import { css } from 'styled-components';
import { Media } from '../../../theme/Media.js';
import { CONTAINER_QHD_MEDIA, CONTAINER_GRID_COLUMN_FLEX_CSS, CONTAINER_GRID_COLUMN_NARROW_CSS, CONTAINER_GRID_COLUMN_WIDE_CSS, CONTAINER_GRID_GAP_SM_MAX_CSS, CONTAINER_GRID_GAP_SM_MIN_CSS, CONTAINER_GRID_COLUMN_FLEX_WIDE_CSS, } from './constants.js';
import { ContainerLayout } from './types.js';
const gridGapStyles = css `
  gap: ${CONTAINER_GRID_GAP_SM_MAX_CSS};

  @media ${Media.smMin} {
    gap: ${CONTAINER_GRID_GAP_SM_MIN_CSS};
  }
`;
const equalLayoutStyles = css `
  grid-template-columns: 1fr;

  @media ${Media.lgMin} {
    grid-template-columns: ${CONTAINER_GRID_COLUMN_FLEX_CSS} ${CONTAINER_GRID_COLUMN_FLEX_CSS};
  }
`;
const equalWideLayoutStyles = css `
  grid-template-columns: 1fr;

  @media ${Media.lgMin} {
    grid-template-columns: ${CONTAINER_GRID_COLUMN_FLEX_WIDE_CSS} ${CONTAINER_GRID_COLUMN_FLEX_CSS};
  }
`;
const sidebarLeftLayoutStyles = css `
  grid-template-columns: 1fr;

  @media ${Media.lgMin} {
    grid-template-columns: ${CONTAINER_GRID_COLUMN_NARROW_CSS} ${CONTAINER_GRID_COLUMN_FLEX_CSS};
  }

  @media ${CONTAINER_QHD_MEDIA} {
    grid-template-columns: ${CONTAINER_GRID_COLUMN_WIDE_CSS} ${CONTAINER_GRID_COLUMN_FLEX_CSS};
  }
`;
const sidebarRightLayoutStyles = css `
  grid-template-columns: 1fr;

  @media ${Media.lgMin} {
    grid-template-columns: ${CONTAINER_GRID_COLUMN_FLEX_CSS} ${CONTAINER_GRID_COLUMN_NARROW_CSS};
  }
`;
export const getGridLayoutStyles = (layout) => {
    const columnStyles = (() => {
        switch (layout) {
            case ContainerLayout.Equal:
                return equalLayoutStyles;
            case ContainerLayout.EqualWide:
                return equalWideLayoutStyles;
            case ContainerLayout.SidebarLeft:
                return sidebarLeftLayoutStyles;
            case ContainerLayout.SidebarRight:
                return sidebarRightLayoutStyles;
        }
    })();
    return css `
    ${gridGapStyles}
    ${columnStyles}
  `;
};
